const faToEnDigits = (input) => {
    if (input === undefined) return;
    let returnModel = "",
        mapper = {
            "۱": "1",
            "۲": "2",
            "۳": "3",
            "۴": "4",
            "۵": "5",
            "۶": "6",
            "۷": "7",
            "۸": "8",
            "۹": "9",
            "۰": "0",
        };

    input = input.toString();
    for (let i = 0; i < input.length; i++)
        if (mapper[input[i]]) returnModel += mapper[input[i]];
        else returnModel += input[i];
    return returnModel;
};

const ConvertPersianNumToLatin = (str) => {
    let newStr = str.replaceAll("،", "").trim();
    newStr = newStr.replaceAll(".", "").trim();
    const eng = faToEnDigits(newStr);

    const split = eng.split("-").map((el) => el.toString().trim());
    const char = `${parseInt(split[2].toString())}`.charAt(1)
        ? `${parseInt(split[2].toString())}`
        : `0${`${parseInt(split[2].toString())}`.charAt(0)}`;
    split.splice(2, 1, char);
    return split.map((el) => (el.length >= 2 ? el : `0${el}`)).join("-");
};
export default ConvertPersianNumToLatin;

export const ConvertPersianValueToLatin = (str) => {

    const eng = faToEnDigits(str);

    
    return eng;
};